import { EVENT_PREFERENCES_UPDATED } from '../preferences/preferences.service';

export const LOCALE_COOKIE_NAME = 'pos.rn.locale';

export const name = 'rnLocaleCookie';
export default function rnLocaleCookieProvider() {
  'ngInject';

  this.getLocale = getLocale;
  this.getTimeZone = getTimeZone;
  this.$get = rnLocaleCookie;

  activateProvider();
  return;

  function activateProvider() {
    checkLocaleQueryParam();
  }

  function getCookiesService() {
    return angular.injector(['ngCookies']).get('$cookies');
  }

  function getWindowService() {
    return angular.injector(['ng']).get('$window');
  }

  function setLocale(locale) {
    let cookie = getLocaleCookie() || {};
    cookie.locale = locale;
    let $cookies = getCookiesService();
    $cookies.putObject(LOCALE_COOKIE_NAME, cookie, getCookieOptions());
  }

  function getLocaleCookie() {
    let $cookies = getCookiesService();
    return $cookies.getObject(LOCALE_COOKIE_NAME);
  }

  function getLocale() {
    return _.get(getLocaleCookie(), 'locale');
  }

  function getTimeZone() {
    return _.get(getLocaleCookie(), 'tz');
  }

  function checkLocaleQueryParam() {
    let locale;
    let hashSplit = window.location.href.split('#');
    if (hashSplit.length > 1) {
      // First see if there is a locale param on the root url
      locale = getLocaleFromString(hashSplit[0]);
      if (!locale) {
        locale = getLocaleFromString(hashSplit[1], true);
      }
    }
    else {
      locale = getLocaleFromString(hashSplit[0]);
    }

    if (locale) {
      let localeParts = locale.split('-');
      if (localeParts.length === 2) {
        localeParts[0] = localeParts[0].toLowerCase();
        localeParts[1] = localeParts[1].toUpperCase();
        locale = localeParts[0] + '-' + localeParts[1];
      }

      setLocale(locale);
    }
  }

  function getLocaleFromString(searchString, rebuildURL = false) {
    let locale;
    let queryParamsBuildUp = '';

    let paramCount = 0;
    let qSplit = searchString.split('?');
    if (qSplit.length > 1) {
      let querySegment = qSplit[1];
      let params = querySegment.split('&');
      paramCount = params.length;
      for (let i = 0; i < params.length; i++) {
        let param = params[i].split('=');
        let key = param[0];
        let value = param[1];
        if (key === 'locale') {
          locale = value;
        }
        else {
          if (i === 0) {
            queryParamsBuildUp += params[i];
          }
          else {
            queryParamsBuildUp += '&' + params[i];
          }
        }
      }
    }

    if (locale && rebuildURL) {
      let hashSplit = window.location.href.split('#');
      let qSplit = hashSplit[1].split('?');
      if (paramCount === 1) {
        window.location.href = hashSplit[0] + '#' + qSplit[0];
      }
      else {
        window.location.href = hashSplit[0] + '#' + qSplit[0] + '?' + queryParamsBuildUp;
      }
    }

    return locale;
  }

  function getCookieOptions() {
    let cookieOptions = {
      path: '/'
    };
    let host = getWindowService().location.hostname;
    if (host.indexOf('.') >= 0) {
      // Browsers won't accept domains that aren't qualified (such as localhost)
      // See http://stackoverflow.com/questions/1134290/cookies-on-localhost-with-explicit-domain
      cookieOptions.domain = host;
    }
    return cookieOptions;
  }

  /** @ngInject */
  function rnLocaleCookie($cookies, $rootScope) {
    let service = {
      // publish provider methods on service as well
      getLocale: getLocale,
      getTimeZone: getTimeZone,
    };
    activate();
    return service;

    function activate() {
      $rootScope.$on(EVENT_PREFERENCES_UPDATED, (event, prefs) => {
        setLocaleCookie(prefs);
      });
    }

    function setLocaleCookie(preferences) {
      let prefsCookie = {};
      let locale = _.get(preferences, 'general.locale');
      if (locale) {
        prefsCookie.locale = locale;
      }
      let timeZone = _.get(preferences, 'general.timeZone');
      if (timeZone) {
        prefsCookie.tz = timeZone;
      }

      if (!_.isEmpty(prefsCookie)) {
        $cookies.putObject(LOCALE_COOKIE_NAME, prefsCookie, getCookieOptions());
      } else {
        $cookies.remove(LOCALE_COOKIE_NAME);
      }
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/locale/locale-cookie.provider.js